import { Pipe } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'appCurrency',
})
export class AppCurrencyPipe extends CurrencyPipe {
  transform(value: number, currencyCode: string): string | null {
    const display = 'symbol';
    const digitsInfo = '0.0-2';

    return super.transform(value, currencyCode, display, digitsInfo);
  }
}
